import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface TempStore {
  isSideNavigationOpen: boolean
  setIsSideNavigationOpen: (isSideNavigationOpen: boolean) => void
  lastPlayedGameIds: number[]
  setLastPlayedGameIds: (lastPlayedGameIds: number[]) => void
  addLastPlayedGameId: (gameId: number) => void
  reset: () => void
}

export const TEMP_STORE_KEY = 'temp_store'

export const useTempStore = create<TempStore>()(
  persist(
    (set) => ({
      isSideNavigationOpen: true,
      setIsSideNavigationOpen: (isSideNavigationOpen: boolean) => set({ isSideNavigationOpen }),
      lastPlayedGameIds: [],
      addLastPlayedGameId: (gameId: number) =>
        set((state) => {
          // Add new gameId at the beginning of the array
          const newArray = [gameId, ...state.lastPlayedGameIds]
          // Limit to maximum 10 items, remove the last item if exceeded
          const limitedArray = newArray.slice(0, 10)
          return { lastPlayedGameIds: limitedArray }
        }),
      setLastPlayedGameIds: (lastPlayedGameIds: number[]) => set({ lastPlayedGameIds }),
      reset: () => set({ lastPlayedGameIds: [], isSideNavigationOpen: true }),
    }),
    {
      name: TEMP_STORE_KEY,
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
